import React, { useState } from "react";
import Flex from "../../components/Flex";
import {
  useAddDiagnostiquesMutation,
  useGetDiagnostiquesQuery,
} from "../../redux/features/diagnostiqueApi";
import { useGetClassesQuery } from "../../redux/features/classeApi";
import { useGetNiveauxQuery } from "../../redux/features/niveauApi";
import { useGetMatiereQuery } from "../../redux/features/matiereApi";
import {
  ActionIcon,
  Button,
  Divider,
  Group,
  Loader,
  Modal,
  Select,
  Space,
  TextInput,
} from "@mantine/core";
import DiagnostiqueTable from "./components/DiagnostiqueTable";
import { useForm } from "@mantine/form";
import AddAction from "./actions/AddAction";
import { Trash } from "tabler-icons-react";
import { useDisclosure } from "@mantine/hooks";
import DeleteAction from "./actions/DeleteAction";
import { useDeleteDiagnostiquesMutation } from "./api/features/diagnostiqueApi";
import toast from "react-hot-toast";

function DiagnostiqueListe() {
  const { data, isLoading } = useGetDiagnostiquesQuery();
  const [addDiagnostiques, { isLoading: isLoadinAaddDiagnostic }] = useAddDiagnostiquesMutation();
  // const [editDiagnostiques] = useEditDiagnostiquesMutation();
  const [deleteDiagnostiques] = useDeleteDiagnostiquesMutation();
  const [opened, { open, close }] = useDisclosure(false);
  const { data: classes } = useGetClassesQuery();
  const { data: niveaux } = useGetNiveauxQuery();
  const { data: matieres } = useGetMatiereQuery();

  // const [opened, setOpened] = useState(false);
  const [query, setQuery] = useState("");
  const [itemEdited, setItemEdited] = useState(null);

  const form = useForm({
    initialValues: {
      classeId: "",
      matiereId: "",
      type_diagnostique: "",
      niveaux: [{ seuil: 0, niveauId: "" }],
    },

    validate: {},
  });

  // Debug: Afficher les valeurs du formulaire en temps réel
  console.log("📋 Valeurs actuelles du formulaire:", form.values);

  // Fonction pour vérifier si un diagnostic existe déjà et le retourner
  const checkDiagnosticExists = (classeId, matiereId, typeDiagnostique) => {
    if (!data?.data) return null;
    
    return data.data.find(diagnostic => 
      diagnostic.classeId === parseInt(classeId) && 
      diagnostic.matiereId === parseInt(matiereId) && 
      diagnostic.type_diagnostique === typeDiagnostique
    );
  };

  // Fonction pour obtenir le nom d'une classe par son ID
  const getClasseName = (classeId) => {
    return classes?.data?.find(classe => classe.id === parseInt(classeId))?.name || `ID: ${classeId}`;
  };

  // Fonction pour obtenir le nom d'une matière par son ID
  const getMatiereName = (matiereId) => {
    return matieres?.data?.find(matiere => matiere.id === parseInt(matiereId))?.name || `ID: ${matiereId}`;
  };

  // console.log({ niveaux });

  // const handleEdit = async () => {
  //   setEditLoadin(true);
  //   const newData = {
  //     ...form,
  //     matiereId: parseInt(form?.matiereId?.value),
  //     classeId: parseInt(form?.classeId?.value),
  //     niveauId: parseInt(form?.niveauId?.value),
  //   };
  //   try {
  //     await editDiagnostiques({
  //       body: { ...newData, id: itemEdited?.id },
  //     });
  //     setEditLoadin(false);
  //     setItemEdited(null);
  //     //   console.log({ res });
  //   } catch (error) {
  //     console.log({ error });
  //     setEditLoadin(false);
  //   }
  // };

  // console.log({ data });
  const typeDiagnostiqueOptions = data?.type_diagnostique
    ? data.type_diagnostique.map((item) => ({
      label: item?.name,
      value: item?.id,
    }))
    : [];

  return (
    <div>
      <Flex position={"apart"} mb={20}>
        {/* <TextInput
          placeholder={"Rechercher un diagnostique"}
          onChange={(value) => setQuery(value.toLowerCase())}
          value={query}
        /> */}
        <Button
          onClick={() => {
            setItemEdited(null);
            form.reset(); // Reset du formulaire à chaque ouverture
            console.log("🔄 Formulaire réinitialisé");
            open(true);
          }}
        >
          Ajouter un diagnostique
        </Button>
      </Flex>

      {isLoading ? (
        <Loader />
      ) : (
        <DiagnostiqueTable
          data={data ? data?.data : [{}]}
          handleAdd={() => { }}
          handleDelete={async (id) =>
            await DeleteAction(deleteDiagnostiques, id)
          }
        />
      )}

      <Space h={30} />

      {/* My modal */}
      <Modal
        opened={opened}
        onClose={() => {
          close();
          form.reset();
          console.log("🔄 Modal fermé et formulaire réinitialisé");
        }}
        title={itemEdited ? "Edit niveaux" : "Ajout de diagnostique"}
      >
        <form
          onSubmit={form.onSubmit(async (values) => {
            // Vérifier si un diagnostic existe déjà pour informer l'utilisateur
            const existingDiagnostic = checkDiagnosticExists(values.classeId, values.matiereId, values.type_diagnostique);
            
            if (existingDiagnostic) {
              const className = getClasseName(values.classeId);
              const matiereName = getMatiereName(values.matiereId);
              
              console.log("ℹ️ Diagnostic existant trouvé - Modification des niveaux:", {
                diagnostic: existingDiagnostic,
                nouveauxNiveaux: values.niveaux
              });
              
              toast.success(`📝 Modification du diagnostic existant: ${className} - ${matiereName} (${values.type_diagnostique})`, {
                duration: 4000
              });
            } else {
              console.log("✨ Création d'un nouveau diagnostic");
            }

            try {
              const response = await addDiagnostiques({ body: values });
              
              if (response?.data?.status === 400) {
                console.error("Erreur 400:", response.data);
                toast.error("Erreur lors de la sauvegarde du diagnostic");
                return;
              }
              
              // Succès - fermer le modal et réinitialiser
              close();
              form.reset();
              
              if (existingDiagnostic) {
                toast.success("✅ Niveaux du diagnostic mis à jour avec succès!");
              } else {
                toast.success("✅ Nouveau diagnostic créé avec succès!");
              }
              
            } catch (error) {
              console.error("Erreur lors de la sauvegarde:", error);
              toast.error("Erreur lors de la sauvegarde du diagnostic");
            }
          })}
        >
          <Select
            placeholder="Matiere"
            withAsterisk
            sx={{ flex: 1 }}
            {...form.getInputProps("matiereId")}
            data={
              matieres
                ? matieres?.data.map((item) => ({
                  label: item?.name,
                  value: item?.id,
                }))
                : []
            }
            mb={10}
            onChange={(value) => {
              form.setFieldValue("matiereId", value);
              console.log("🔍 Matière sélectionnée:", {
                value,
                valueType: typeof value,
                matiereName: matieres?.data?.find(m => m.id === parseInt(value))?.name,
                formValuesAfter: form.values
              });
            }}
          />

          <Select
            placeholder="classes"
            mb={10}
            withAsterisk
            sx={{ flex: 1 }}
            {...form.getInputProps("classeId")}
            data={
              classes
                ? classes?.data.map((item) => ({
                  label: item?.name,
                  value: item?.id,
                }))
                : []
            }
            onChange={(value) => {
              form.setFieldValue("classeId", value);
              console.log("🔍 Classe sélectionnée:", {
                value,
                className: classes?.data?.find(c => c.id === parseInt(value))?.name
              });
            }}
          />

          <Select
            placeholder="Type de diagnostique"
            withAsterisk
            sx={{ flex: 1 }}
            {...form.getInputProps("type_diagnostique")}
            data={[
              { label: "Demo", value: "DEMO" },
              { label: "Normal", value: "NORMAL" },
              ...typeDiagnostiqueOptions
            ]}
            mb={10}
            onChange={(value) => {
              form.setFieldValue("type_diagnostique", value);
              console.log("🔍 Type de diagnostic sélectionné:", value);
            }}
          />

          {form.values.matiereId && (
            <>
              <Divider label="Liste des niveaux" />
              
              {/* Afficher un message si aucun niveau n'existe pour cette matière */}
              {niveaux?.data?.filter(item => item?.matiereId === parseInt(form.values.matiereId)).length === 0 && (
                <div style={{ padding: '10px', backgroundColor: '#fff3cd', border: '1px solid #ffeaa7', borderRadius: '4px', marginBottom: '10px' }}>
                  ⚠️ Aucun niveau disponible pour cette matière. Veuillez d'abord créer des niveaux dans la section "Niveaux".
                </div>
              )}
              
              {form.values.niveaux.map((item, index) => {
                const availableNiveaux = niveaux?.data
                  ?.filter(niveau => niveau?.matiereId === parseInt(form.values.matiereId))
                  ?.map(niveau => ({
                    label: niveau?.name,
                    value: niveau?.id,
                  })) || [];
                
                return (
                  <Group key={index} mt="xs">
                    <Select
                      label="Selectionner le niveau"
                      placeholder={availableNiveaux.length === 0 ? "Aucun niveau disponible" : "Sélectionner un niveau"}
                      withAsterisk
                      sx={{ flex: 1, width: "100%" }}
                      {...form.getInputProps(`niveaux.${index}.niveauId`)}
                      data={availableNiveaux}
                      disabled={availableNiveaux.length === 0}
                    />
                    <TextInput
                      label="Seuil"
                      type="number"
                      {...form.getInputProps(`niveaux.${index}.seuil`)}
                      w={70}
                    />
                    <ActionIcon
                      color="red"
                      onClick={() => form.removeListItem("niveaux", index)}
                    >
                      <Trash size="1rem" />
                    </ActionIcon>
                  </Group>
                );
              })}
              
              {form.values.niveaux.length === 3 ? null : (
                <Button
                  onClick={() =>
                    form.insertListItem("niveaux", { niveauId: "", seuil: 21 })
                  }
                  mt={10}
                  disabled={niveaux?.data?.filter(item => item?.matiereId === parseInt(form.values.matiereId)).length === 0}
                >
                  Ajout niveau
                </Button>
              )}
            </>
          )}

          <Divider my={20} />

          <Group position="right">
            <Button variant="light" onClick={close}>
              Annuler
            </Button>
            <Button type="submit" disabled={isLoadinAaddDiagnostic}>
              {
                isLoadinAaddDiagnostic ? "En cours..." : "Ajouter"
              }
              {console.log(isLoadinAaddDiagnostic)}
            </Button>
          </Group>
        </form>
      </Modal>
    </div>
  );
}

export default DiagnostiqueListe;
